import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OnboardingRequirements } from '../../services/federator-onboarding.service';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
const GX = 'https://w3id.org/gaia-x/development#';
const NAME = 'https://schema.org/name';
@Component({ selector: 'app-legal-person-onboarding', standalone: false, templateUrl: './legal-person-onboarding.component.html', styleUrls: ['./legal-person-onboarding.component.scss'] })
export class LegalPersonOnboardingComponent implements OnInit {
  @Input() requirements!: OnboardingRequirements;
  @Output() formReady = new EventEmitter<FormGroup>();
  form!: FormGroup;
  sameAddress = true;
  addressFields: any[] = [];
  readonly namePath = NAME;
  readonly descriptionPath = 'https://schema.org/description';
  readonly registrationTypes = [
    { label: 'Umsatzsteuer-Nr. (VAT)', path: GX + 'vatID' },
    { label: 'Legal Entity Identifier (LEI)', path: 'https://schema.org/leiCode' },
    { label: 'Europäische Unternehmens-ID (EUID)', path: GX + 'euid' },
    { label: 'EORI-Nummer', path: GX + 'eori' },
    { label: 'Handelsregisternummer', path: GX + 'local' }
  ];
  readonly countryCodes = [
    ['AT', 'Österreich'], ['BE', 'Belgien'], ['BG', 'Bulgarien'], ['CH', 'Schweiz'], ['CY', 'Zypern'], ['CZ', 'Tschechien'], ['DE', 'Deutschland'], ['DK', 'Dänemark'], ['EE', 'Estland'], ['ES', 'Spanien'], ['FI', 'Finnland'], ['FR', 'Frankreich'], ['GR', 'Griechenland'], ['HR', 'Kroatien'], ['HU', 'Ungarn'], ['IE', 'Irland'], ['IT', 'Italien'], ['LI', 'Liechtenstein'], ['LT', 'Litauen'], ['LU', 'Luxemburg'], ['LV', 'Lettland'], ['MT', 'Malta'], ['NL', 'Niederlande'], ['NO', 'Norwegen'], ['PL', 'Polen'], ['PT', 'Portugal'], ['RO', 'Rumänien'], ['SE', 'Schweden'], ['SI', 'Slowenien'], ['SK', 'Slowakei']
  ];
  constructor(private fb: FormBuilder, private organisations: OrganisationService) {}
  ngOnInit() {
    const addressShape = this.requirements.shape.nestedShapes[GX + 'Address'];
    this.addressFields = (addressShape?.properties || []).filter(field => !field.clazz).sort((a,b) => this.order(a.path)-this.order(b.path));
    const org = this.organisations.activeOrganisation;
    this.form = this.fb.group({ [NAME]: [org?.organisationName || org?.name || '', Validators.required],
      [GX + 'headquartersAddress']: this.address(), [GX + 'legalAddress']: this.address(),
      [GX + 'registrationNumber']: this.fb.array([], Validators.required), [this.descriptionPath]: [''] });
    this.addRegistration();
    this.business.valueChanges.subscribe(value => { if (this.sameAddress) this.legal.patchValue(value, { emitEvent: false }); });
    this.formReady.emit(this.form);
  }
  private address(): FormGroup {
    const address = this.organisations.activeOrganisation?.address;
    const initial: Record<string,string> = { 'street-address': address?.street || '', 'postal-code': address?.postalCode || '', locality: address?.city || '', countryCode: 'DE' };
    const group = this.fb.group({});
    for (const field of this.addressFields) {
      const options = (field as any).inVals || field.inValues || [];
      const validators = field.required ? [Validators.required] : [];
      if (options.length) validators.push(control => !control.value || options.includes(control.value) ? null : { enumeration: true });
      group.addControl(field.path, this.fb.control(initial[field.path.split(/[#/]/).pop()!] || '', validators));
    }
    return group;
  }
  label(path: string): string {
    const labels: Record<string,string> = { 'street-address':'Straße und Hausnummer', 'postal-code':'Postleitzahl', locality:'Stadt', countryCode:'Ländercode (z. B. DE)', countryName:'Land', region:'Region (NUTS2-Code, z. B. DE30)' };
    return labels[path.split(/[#/]/).pop()!] || path.split(/[#/]/).pop()!;
  }
  private order(path: string) { const index=['street-address','postal-code','locality','countryName','countryCode','region'].indexOf(path.split(/[#/]/).pop()!); return index<0?99:index; }
  get business() { return this.form.controls[GX + 'headquartersAddress'] as FormGroup; }
  get legal() { return this.form.controls[GX + 'legalAddress'] as FormGroup; }
  get registrations() { return this.form.controls[GX + 'registrationNumber'] as FormArray; }
  registrationGroup(index: number) { return this.registrations.at(index) as FormGroup; }
  registrationPath(index: number) { return Object.keys(this.registrationGroup(index).controls)[0]; }
  addRegistration() { this.registrations.push(this.fb.group({ [this.registrationTypes[0].path]: ['', Validators.required] })); }
  removeRegistration(index: number) { if (this.registrations.length > 1) this.registrations.removeAt(index); }
  changeType(index: number, path: string) {
    const group=this.registrationGroup(index), old=this.registrationPath(index), value=group.controls[old].value;
    group.removeControl(old); group.addControl(path,this.fb.control(value,Validators.required)); group.markAsDirty();
  }
  copyAddress(checked: boolean) { this.sameAddress=checked; if(checked) this.legal.patchValue(this.business.value); this.form.markAsDirty(); }
}
